// extracted by mini-css-extract-plugin
export var standaloneTable = "_y-0";
export var standaloneTableWithBodyFill = "_y-1";
export var withExtraHeader = "_y-2";